import React from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import Dialog from '../../../utilities/Dialog';
import { User } from './ManageAccessCodes';
import IconButton from '../../common/IconButton';
import axios from 'axios';
import AxiosConfig from '../../../utilities/AxiosConfig';

const UserRow: React.FC<any> = (props: {user: User, resetCb: any, deleteCb: any}) => {
    const { user, deleteCb } = props;
    const [isDeleting, setIsDeleting] = React.useState(false);
    const [isReseting, setIsReseting] = React.useState(false);
    const [resetSuccess, setResetSuccess] = React.useState(false);

    const handleDelete = async(e: React.SyntheticEvent) => {
        e.preventDefault();
        let confirm = new Dialog({ type: "confirm", message: `You are about to delete ${user.UserName}. Continue?` });
        let answer = await confirm.show();
        if(answer){
            setIsDeleting(true);
            axios.get(process.env.REACT_APP_API_URL + `/api/user/deleteaccesscode/${user.UserId}`, AxiosConfig.configValue("min"))
            .then(async (res: any) => {
                //console.log("handleDelete Response: ", res);
                await deleteCb(user.UserId);
            })
            .catch((err: any) => {
                //console.log(err, err.response);
            })
        }
    }

    const handleReset = async(e: React.SyntheticEvent) => {
        e.preventDefault();
        let confirm = new Dialog({ type: "confirm", message: `You are about to reset ${user.UserName}'s code. Continue?` });
        let answer = await confirm.show();
        if(answer){
            setIsReseting(true);
            axios.get(process.env.REACT_APP_API_URL + `/api/user/resetaccesscode/${user.UserId}`, AxiosConfig.configValue("min"))
            .then(async (res: any) => {
                //console.log(res);
                setIsReseting(false);
                setResetSuccess(true);
                setTimeout(() => {
                    setResetSuccess(false);
                }, 1000)
            })
            .catch((err: any) => {
                //console.log(err, err.response);
            })
        }
    }

    return(
        <ListGroup.Item key={user.UserId} className="d-flex flex-row justify-content-between align-items-center border-right-0 border-left-0">
            <span style={{maxWidth: "50%"}} className="overflow-ellipsis">{user.UserName}</span>
            <span className="overflow-ellipsis ml-5">{user.AreaDesc}</span>
            <div className="d-flex justify-content-between align-items-center">
                <IconButton spinnerText="Deleting" icon="delete" disabled={isDeleting} showSpinner={isDeleting} onClick={handleDelete} buttonClassName="action-text-danger border-0 p-1">
                    Delete
                </IconButton>
                <IconButton 
                    spinnerText="Reseting" 
                    icon={ resetSuccess ? "check" : "restart_alt"} 
                    disabled={isReseting} 
                    showSpinner={isReseting} 
                    onClick={handleReset} 
                    buttonClassName={`action-text border-0 p-1 ${resetSuccess && "text-success"}`}
                >
                    { resetSuccess ? "Success!" : "Reset Code" }
                </IconButton>
            </div>
        </ListGroup.Item>
    )
}

export default UserRow;